function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var genStatusStyle = function genStatusStyle(token) {
  var componentCls = token.componentCls,
      menuCls = token.menuCls,
      colorError = token.colorError,
      colorTextLightSolid = token.colorTextLightSolid;
  var itemCls = "".concat(menuCls, "-item");
  return _defineProperty({}, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), _defineProperty({}, "".concat(menuCls, " ").concat(itemCls), _defineProperty({}, "&".concat(itemCls, "-danger:not(").concat(itemCls, "-disabled)"), {
    color: colorError,
    '&:hover': {
      color: colorTextLightSolid,
      backgroundColor: colorError
    }
  })));
};

export default genStatusStyle;